import { snapshot } from 'valtio';
import { logger } from 'logging-utils';
import policiesService from '../../services';
import PoliciesStore from '../../store/policies';
import ProfileStore from '../../store/profiles';
import { IFetchProfilePoliciesByCategoryIdRes } from '../../types/policies-types';
import { setLoadingProfilePoliciesByCategory } from '../policies-selection-ui-actions/policies-selection-ui-actions';

export default async function fetchProfilePoliciesByCategoryAction(
  categoryId: number,
): Promise<void> {
  try {
    setLoadingProfilePoliciesByCategory(true);
    const profileStore = snapshot(ProfileStore);
    if (!profileStore.profileInContext) {
      logger.error('No profile in context');
      return;
    }
    const profileId = profileStore.profileInContext.profileId;
    const { policies }: IFetchProfilePoliciesByCategoryIdRes =
      await policiesService.fetchProfilePoliciesByCategoryId.execute({
        profileId,
        categoryId,
      });

    policies.forEach(p => {
      PoliciesStore.policies[p.id] = p;
    });
  } catch (err) {
  } finally {
    setLoadingProfilePoliciesByCategory(false);
  }
}
